/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { User } from 'types/user';
import * as qs from 'qs';

type PaginationType = {
  page: number;
  size: number;
  searchText?: string;
};

export type UserInfo = {
  id: string;
  role: string;
  firstName: string;
  lastName: string;
  address: string;
  email: string;
  lastLoginAt: any;
  isActive: boolean;
  userDocuments: { url: string; fileName: string; id: number }[];
};

export const adminGetUser = async ({ page, size }: PaginationType) => {
  const { data } = await axios.get(`/admin/users?page=${page || 1}&size=${size}`);
  return data;
};

export const adminGetAllUser = async ({ isActive }: { isActive?: boolean }) => {
  const query = qs.stringify({
    isActive
  });
  const { data } = await axios.get(`/admin/users-all?${query}`);
  return data;
};
export const adminGetAdmins = async ({ page, size }: PaginationType) => {
  const { data } = await axios.get(`/admin/users-admin?page=${page || 1}&size=${size}`);
  return data;
};

export const adminGetDetailUser = async (id: number) => {
  const { data } = await axios.get(`/admin/users/${id}`);
  return data;
};
export const adminUpdateUser = async (id: number, payload: Partial<User>) => {
  const { data } = await axios.put(`/admin/users/${id}`, payload);
  return data;
};
export const adminCreateUser = async (payload: Partial<User>) => {
  const { data } = await axios.post(`/admin/users`, payload);
  return data;
};

export const adminGetArchive = async ({ page, size, searchText }: PaginationType) => {
  const query = qs.stringify({
    page,
    size,
    searchText
  });
  const { data } = await axios.get(`/admin/archives?${query}`);
  return data;
};

export const adminDeleteUser = async (id: string) => {
  const { data } = await axios.delete(`/admin/users/${id}`);
  return data;
};
